export default function() {
  if (document.body.classList.contains("dev")) {
    return "development";
  } else {
    return "production";
  }
}



// WEBPACK FOOTER //
// ./src/js/helpers/getEnv.js